import { FiltersVariant } from '@models/Filter';

export enum Part {
    TilesSort,
    DatePeriod,
    DateSeason,
    DateRange,
    Concepts,
    Segments,
    SegmentsToggles,
    ClSegments,
    Chain,
    Categories,
    Status,
    KeyMetric,
    NewItemsPreview,
    Keywords,
}

export const CONFIG = new Map<Part, FiltersVariant[]>([
    [Part.TilesSort, [
        FiltersVariant.Homepage,
        FiltersVariant.ConceptLocker,
    ]],
    [Part.DatePeriod, [
        FiltersVariant.Homepage,
        FiltersVariant.ConceptLocker,
        FiltersVariant.Chains,
        FiltersVariant.Foods,
        FiltersVariant.ChainsChart,
        FiltersVariant.ChainProfile,
        FiltersVariant.Seasonal,
        FiltersVariant.CategoryActivity,
    ]],
    [Part.DateSeason, [
        FiltersVariant.Homepage,
        FiltersVariant.ConceptLocker,
    ]],
    [Part.DateRange, [
        FiltersVariant.Homepage,
        FiltersVariant.ConceptLocker,
        FiltersVariant.Chains,
        FiltersVariant.Foods,
        FiltersVariant.ChainsChart,
        FiltersVariant.ChainProfile,
        FiltersVariant.Seasonal,
        FiltersVariant.CategoryActivity,
    ]],
    [Part.Concepts, [
        FiltersVariant.Homepage,
        FiltersVariant.ConceptLocker,
    ]],
    [Part.Segments, [
        FiltersVariant.Homepage,
        FiltersVariant.ConceptLocker,
        FiltersVariant.Chains,
        FiltersVariant.Foods,
        FiltersVariant.Seasonal,
        FiltersVariant.CategoryActivity,
    ]],
    [Part.SegmentsToggles, [
        FiltersVariant.Homepage,
        FiltersVariant.ConceptLocker,
    ]],
    [Part.ClSegments, [
        FiltersVariant.Homepage,
        FiltersVariant.ConceptLocker,
    ]],
    [Part.Chain, [
        FiltersVariant.Homepage,
        FiltersVariant.ConceptLocker,
        FiltersVariant.Foods,
        FiltersVariant.Seasonal,
        FiltersVariant.CategoryActivity,
    ]],
    [Part.Categories, [
        FiltersVariant.Homepage,
        FiltersVariant.ConceptLocker,
        FiltersVariant.Chains,
        FiltersVariant.Foods,
        FiltersVariant.ChainsChart,
        FiltersVariant.ChainProfile,
        FiltersVariant.Seasonal,
    ]],
    [Part.Status, [
        FiltersVariant.Homepage,
    ]],
    [Part.KeyMetric, [
        FiltersVariant.Homepage,
        FiltersVariant.ConceptLocker,
    ]],
    [Part.NewItemsPreview, [
        FiltersVariant.Homepage,
    ]],
    [Part.Keywords, [
        FiltersVariant.ConceptLocker,
        FiltersVariant.Chains,
        FiltersVariant.ChainProfile,
        FiltersVariant.Foods,
        FiltersVariant.Seasonal,
        FiltersVariant.CategoryActivity,
    ]],
]);

export const checkFilterVariantParts = (variant: FiltersVariant) => {
    return (...pieces: Part[]): boolean => pieces.some(piece => (
        CONFIG.get(piece)?.includes(variant) || false
    ));
};

